import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Main',
		component: () => import('../views/Main.vue'),
		redirect:'/home',
		children: []
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('../views/login.vue')
	},
	{
		path: '/iothome',
		name: 'iothome',
		component: () => import('../views/iothome/index.vue')
	},

	{//设备在线监测
		path: '/deviceOnlineMonitor',
		name: 'deviceOnlineMonitor',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/iotend/deviceOnlineMonitor')
	},
	{//数据转发监测
		path: '/dataForwardingMonitor',
		name: 'dataForwardingMonitor',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/iotend/dataForwardingMonitor')
	},
	{//设备预警
		path: '/deviceWarn',
		name: 'deviceWarn',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/iotend/deviceWarn')
	},
	{//业务数据
		path: '/businessDataAnalysis',
		name: 'businessDataAnalysis',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/iotend/businessDataAnalysis')
	},
	{//业务指标分析
		path: '/quotaAnalysis',
		name: 'quotaAnalysis',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/iotend/quotaAnalysis')
	},
	{//OpenAPI
		path: '/openAPI',
		name: 'openAPI',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/interface/openAPI')
	},
	{//操作手册
		path: '/operateBook',
		name: 'operateBook',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/iotend/operateBook')
	},
	{//视频调阅
		path: '/myvideo',
		name: 'myvideo',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/iotend/myVideo')
	},


	{//视频接入
		path: '/videoAccess',
		name: 'videoAccess',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/deviceAccess/videoAccess')
	},
	{//视频接入配置
		path: '/videoInterface',
		name: 'videoInterface',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/interface/video/videoInterface')
	},
	{//视频通道列表界面
		path: '/videoChannels',
		name: 'videoChannels',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/deviceAccess/channelList')
	},

	{//IOT设备
		path: '/iotDevice',
		name: 'iotDevice',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/iotDevice/iotDevice')
	},
	{//IOT设备建模
		path: '/iotDeviceModel',
		name: 'iotDeviceModel',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/iotDevice/iotDeviceModel')
	},
	{//IOT设备模型详情设置
		path: '/iotDeviceModelSet',
		name: 'iotDeviceModelSet',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/iotDevice/iotDeviceModelSet')
	},
	{//IOT设备接入
		path: '/iotDeviceAccess',
		name: 'iotDeviceAccess',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/iotDevice/iotDeviceAccess')
	},
	{//IOT设备接入接口配置
		path: '/iotDeviceInterface',
		name: 'iotDeviceInterface',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/iotDevice/iotDeviceInterface')
	},
	{//数据转发配置
		path: '/dataForwarding',
		name: 'dataForwarding',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/iotDevice/dataForwarding')
	},

	{//系统参数设置
		path: '/sysparaconfig',
		name: 'sysparaconfig',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/sysparaconfig')
	},
	{//IOT终端域名绑定设置
		path: '/iotTerminalSettings',
		name: 'iotTerminalSettings',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/iotTerminalSettings')
	},
	{//账号安全设置
		path: '/accsecset',
		name: 'accsecset',
		meta: {
			requireAuth: true
		},
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/accsecset')
	},
	{//恢复出厂设置
		path: '/restoresettings',
		name: 'restoresettings',
		component: () => import(/* webpackChunkName: "about" */ '../views/pages/restoresettings')
	}
]

const route = new VueRouter({
	// mode: 'history',
	routes
})

export default route
